import { WideQuantityListSkin } from './wide/wide-quantity-list-skin.mjs';

function getQuantityListComponentBySkin(skin) {
    switch (skin) {
        case "wide":
            return WideQuantityListSkin;
        default:
            return WideQuantityListSkin;
    }
}

export { getQuantityListComponentBySkin as default };
//# sourceMappingURL=index.mjs.map
